import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import DefaultLayout from "/home/runner/work/credit-suisse-cop-hackathon-sept16/credit-suisse-cop-hackathon-sept16/node_modules/gatsby-theme-carbon/src/templates/Default.js";
import HomepageTemplate from "../components/Homepage.js";
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const PageDescription = makeShortcode("PageDescription");
const layoutProps = {
  _frontmatter
};
const MDXLayout = HomepageTemplate;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">




    <h2>{`Introduction`}</h2>
    <PageDescription mdxType="PageDescription">
Welcome to the <span>Credit Suisse</span> Hackathon, organized by the Cloud CoP India.
      <p>{`You’ll find some great information here to get started with Microsoft Azure Cloud.`}</p>
    </PageDescription>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      